var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h3',{attrs:{"id":"commonError"}},[_vm._v(_vm._s(_vm.headingText))]),_c('p',{attrs:{"id":"message"}},[_vm._v(_vm._s(_vm.messageText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }